import {WhiteSpace, WingBlank,Modal} from 'antd-mobile';
import './Contact.css';
import CONF_LAN from "./config/LAN";
import React from "react";

function ContactMainItemComp ({icon,title}) {
        return (
            <div className={'contact-main-item'}>
                <img className={'item-icon'} src={icon}/>
                <span className={'item-title'} dangerouslySetInnerHTML={{__html:title}}></span>
            </div>
        );
}
class ContactSubItemsComp extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            'dialog_visible':false,
            'dialog_img':'',
        }
    }
    onClick(val){
        switch(val.type){
            case "URL":
                window.open(val.url);
                break;
            case "DIALOG_IMG":
                this.setState({
                    'dialog_visible':true,
                    'dialog_img':val.img
                })
                break;
            default:
                break;
        }
    }
    onCloseDialog(){
        this.setState({
            'dialog_visible':false
        })
    }
    componentDidMount() {

    }
    render() {
        let {objs}=this.props;
        let subs=[];
        objs.sort((a,b)=>a['seq']-b['seq']);
        for(let k in objs){
            subs.push(
                <div onClick={this.onClick.bind(this,objs[k])} style={{'backgroundImage':'url('+CONF_LAN[CUR_LAN]['img_dir']+'sns.png'+')'}} className={"contact-sub-item "+"contact-sub-item-seq-"+objs[k]['sprit_index']}></div>
            )
        }
        return (

            <div className={'contact-sub-items'}>
                {subs}
                <Modal
                    visible={this.state.dialog_visible}
                    transparent
                    closable={true}
                    maskClosable={true}
                    onClose={this.onCloseDialog.bind(this)}
                >
                    <img style={{'maxWidth':'100%'}} src={this.state.dialog_img} />
                </Modal>
            </div>
        );
    }
}

class ContactComp extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }
    render() {
        let contactMains=[];
        for(let k in CONF_LAN[CUR_LAN]['contact']){
            contactMains.push(
                <ContactMainItemComp icon={CONF_LAN[CUR_LAN]['contact'][k].icon} title={CONF_LAN[CUR_LAN]['contact'][k].title}></ContactMainItemComp>
            )
        }
        return (
            <div className={'contact-comp-outer '+CUR_LAN}>
                <WhiteSpace size='md' />
                {/*<WingBlank size="sm">*/}
                    <div  className="am-list-item am-list-item-middle">
                        <div className="am-list-line">
                            <div className="am-list-content">
                                <div>
                                    <div style={{"padding-bottom":"0px"}}></div>
                                    <div
                                        className="sticky contact-title-bg"
                                        style={{
                                            zIndex: 4,
                                        }}
                                    >
                                        <img className={'title-img contact-title-img'} src={CONF_LAN[CUR_LAN]['img_dir']+'Contact_title.png'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"contact-main-items"}>
                        {contactMains}
                    </div>
                    <div>
                        <div className={"contact-sep"}></div>
                        <ContactSubItemsComp objs={CONF_LAN[CUR_LAN]['contact_subs']} />
                    </div>
                {/*</WingBlank>*/}
            </div>
        );
    }
}
export default  ContactComp;